export default "__VITE_ASSET__BmRI25rc__"